<script lang="ts">
  import { Milestone } from "@models/milestones/Milestone"
  export let milestones: Milestone[]
  export let milestone: Milestone

  function milestoneLabelText(milestones: Milestone[], milestone: Milestone) {
    if (isFinal(milestones, milestone)) {
      return "Final Payment"
    } else if (isDeposit(milestones, milestone)) {
      return "Deposit"
    } else {
      return "Payment"
    }

    function isDeposit(milestones: Milestone[], milestone: Milestone): boolean {
      return milestones.indexOf(milestone) === 0
    }

    function isFinal(milestones: Milestone[], milestone: Milestone): boolean {
      const index = milestones.indexOf(milestone)
      return index === milestones.length - 1 && index != -1
    }
  }
</script>

{milestoneLabelText(milestones, milestone)}
